import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const CherryBlossoms = () => {
  const [petals, setPetals] = useState([]);

  useEffect(() => {
    const initialPetals = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      delay: Math.random() * 5,
      duration: 10 + Math.random() * 10,
      size: 8 + Math.random() * 12,
      rotation: Math.random() * 360
    }));
    setPetals(initialPetals);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-10">
      {petals.map((petal) => (
        <motion.div
          key={petal.id}
          className="absolute"
          style={{
            left: `${petal.x}%`,
            top: -20,
            width: petal.size,
            height: petal.size,
          }}
          initial={{ y: -20, rotate: petal.rotation, opacity: 0.8 }}
          animate={{
            y: ['0vh', '110vh'],
            x: [0, Math.sin(petal.id) * 100, Math.sin(petal.id) * -50, Math.sin(petal.id) * 80],
            rotate: [petal.rotation, petal.rotation + 360 * 2],
            opacity: [0.8, 0.9, 0.7, 0.5, 0]
          }}
          transition={{
            duration: petal.duration,
            delay: petal.delay,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" className="w-full h-full">
            <path
              d="M12 2C12 2 8 6 8 10C8 14 12 16 12 16C12 16 16 14 16 10C16 6 12 2 12 2Z"
              fill="#FFB7C5"
              opacity="0.9"
            />
            <path
              d="M12 16C12 16 8 18 8 20C8 22 12 24 12 24C12 24 16 22 16 20C16 18 12 16 12 16Z"
              fill="#FFC0CB"
              opacity="0.7"
            />
          </svg>
        </motion.div>
      ))}
    </div>
  );
};

export default CherryBlossoms;
